export default "__VITE_PUBLIC_ASSET__7b737a97__"